import { type Style } from '@glitz/core';
import { styled } from '@glitz/react';
import { DEFAULT_DURATION, DEFAULT_TIMING_FUNCTION } from './utils';

type TransitionPropType = Style['transition'] & { willChange?: boolean };

export function createTransitionDecorator({
  property,
  duration = DEFAULT_DURATION,
  timingFunction = DEFAULT_TIMING_FUNCTION,
  delay,
  willChange,
}: TransitionPropType) {
  const value = Array.isArray(property) ? property.join(', ') : property;
  return styled({
    transition: {
      property: value,
      duration,
      timingFunction,
      delay,
    },
    willChange: willChange ? value : undefined,
  });
}

type AnimationPropType = Style['animation'] & { name: Style['animationName'] };

export function createAnimationDecorator({
  name,
  duration = DEFAULT_DURATION,
  timingFunction = DEFAULT_TIMING_FUNCTION,
  delay,
  direction,
  fillMode,
  iterationCount,
  playState,
}: AnimationPropType) {
  return styled({
    animation: {
      name,
      duration,
      timingFunction,
      delay,
      direction,
      fillMode,
      iterationCount,
      playState,
    },
  });
}

export const fadeInDecorator = styled({
  transition: {
    property: 'opacity',
    duration: 200,
    timingFunction: 'ease-in',
  },
  willChange: 'opacity',
  opacity: 1,
});

export function createFlipYDecorator(open: boolean) {
  return styled(createTransitionDecorator({ property: 'transform' }), { transform: open ? 'scaleY(-1)' : 'scaleY(1)' });
}
